<script lang="ts">
	import type { ProductForCard } from "@components/ProductCard.js";
	import ProductCard from "@components/ProductCard.svelte";
	import Formatted from "@components/common/Formatted.svelte";
	import { getTranslate } from "@utils/getTranslate.js";
	import type { Snippet } from "svelte";
	import type { ClassValue } from "svelte/elements";
	import type { SubcategoryForCustomer } from "@core/schema/Subcategory.js";
	import translations from "./ProductB2cListingGrid.translations.json" with { type: "json" };

	const {
		products,
		subcategories,
		class: customClass,
		children,
	}: {
		products: ProductForCard[];
		subcategories: SubcategoryForCustomer[];
		class?: ClassValue;
		children?: Snippet;
	} = $props();

	const translate = getTranslate(translations);
</script>

<div class={["grid-container full-width [--container-gap:1rem] gap-y-20 b2c-listing pb-20", customClass]}>
	{@render children?.()}
	{#each products as product, index (product)}
		{@const subcategory = subcategories.find(({ id }) => id === product.subcategoryId)}
		{#if subcategory}
			<ProductCard
				{product}
				{subcategory}
				eager={index === 0}
				class="mx-auto w-full max-w-100 md:max-w-none md:min-w-78 xl:w-[min(calc(25vw-var(--container-gap)*2),var(--spacing)*81.5)] xl:min-w-0 2xl:w-full product-card"
			/>
		{/if}
	{:else}
		<div class="text-fcrdarkgray col-span-full text-center my-5">
			<Formatted text={translate("noProducts")} />
		</div>
	{/each}
</div>
